import { render, staticRenderFns } from "./TotalBillingReport.vue?vue&type=template&id=24cfb314"
import script from "./TotalBillingReport.vue?vue&type=script&lang=js"
export * from "./TotalBillingReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports